import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import format from 'date-fns/format';

const styles = theme => ({
  eateryPhotosBox: {
    textAlign: 'right',
  },
  sliderImg: {
    position: 'relative',
    float: 'left',
    // width: "auto",
    height: '200px',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  light: {
    fontSize: '0.8em',
  },
});

const PhotoSlider = props => {
  const { classes, photo } = props;
  let credit = photo.picCredits ? (
    <span className={classes.light}>Photo Credit: {photo.picCredits}</span>
  ) : (
      ''
    );
  return (
    <div className={classes.eateryPhotosBox}>
      <img src={photo.uri} alt={photo.name} className={classes.sliderImg} />
      {credit}
    </div>
  );
};

PhotoSlider.propTypes = {
  classes: PropTypes.object.isRequired,
  photo: PropTypes.object.isRequired,
};

export default withStyles(styles)(PhotoSlider);
